import React, {
  memo,
  useState,
  useMemo,
  useCallback,
  useEffect,
  useContext,
} from 'react';
// import { Card } from 'tea-component';
import CommonSourceCard from '@gp/components/CommonSourceCard';
// import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import EllipsisTextBubble from '../../../EllipsisTextBubble';
import DataTime from '@gp/components/DataTime';
// import ProjectItem from '@gp/components/ProjectItem';
// import Iconfont from '@gp/components/Iconfont';
// import GeneralModal from '@gp/components/GeneralModal';
import ChartCard from './components/ChartCard';
import { useHistory } from 'umi';
import { MENU_ID_MAP, SLASH_G_POP } from '@gp/constants/const';
import { useRequest } from 'ahooks';
import { fetchStudioOverallProjectsKeyMetricsData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import useData from './hooks/useData';
import { getValidDate, getNumberOfDotUnit } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import { context as Context } from '@gp/components/Context';
import gameIcon from '@gp/assets/svg/gameInformation/game.svg';
import defaultGameIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import './index.scss';
import LogoList from '@/pages/globalpedia/pages/StudioDashboard/StudioOverall/components/LogoList';

const getValue = (data: string | number | undefined): string => {
  return data ? getNumberOfDotUnit(parseInt(String(data))) : '0';
};

interface KeyMetricsPropsType {}

const DEFAULT_PROPS: KeyMetricsPropsType = {};

function KeyMetrics(props: KeyMetricsPropsType) {
  const {} = props;

  const history = useHistory();
  const { filter }: StudioOverallProjectsContextType =
    useContext(Context) || {};

  // const [visible, setVisible] = useState<boolean>(false);
  // const [visibleMore, setVisibleMore] = useState<boolean>(false);

  const { loading, data, run } = useRequest(
    fetchStudioOverallProjectsKeyMetricsData,
    { manual: true },
  );

  const {
    devProjectCount,
    yearProjectCount,
    businessOwner,
    status,
    platform,
    genre,
    dataTime,
  } = useData({ loading, data });

  /* const chartOpt = useMemo(() => {
    return [
      {
        title: 'Business Owner',
        data: businessOwner,
      },
      {
        title: 'Status',
        data: status,
      },
      {
        title: 'Platform',
        data: platform,
      },
      {
        title: 'Genre',
        data: genre,
      },
    ];
  }, [businessOwner, status, platform, genre]); */

  const toDetails = useCallback((item: any, e: React.MouseEvent<Element, MouseEvent> | null, isJump = true) => {
    if (!item?.id) return '';
    const filter = encodeURIComponent(
      JSON.stringify({
        project: item?.name,
        projectId: item?.id,
        menuFrom: MENU_ID_MAP['pipeline_all-projects'], // 用于标识左侧菜单栏当前选中高亮
      }),
    );
    const url = SLASH_G_POP + `/Pipeline/ProjectList/Detail?filter=${filter}`;
    if (isJump) {
      e?.preventDefault();
      e?.stopPropagation();
      history.push(url);
    }

    return url;
  }, []);

  /* const handleResize = useCallback(() => {
    const projectsContainer = document.querySelector(
        '.dbg-studio-overall-projects-development-key-metrics-card-projects-container',
      ),
      projectsInnerBox = document.querySelector(
        '.dbg-studio-overall-projects-development-key-metrics-card-projects-box',
      );
    if (projectsContainer && projectsInnerBox) {
      setVisibleMore(
        projectsContainer?.clientWidth < projectsInnerBox?.clientWidth,
      );
    } else {
      setVisibleMore(false);
    }
  }, []); */

  // 筛选器变化
  useEffect(() => {
    run({
      bo: filter?.bo || [],
      project: filter?.project || [],
    });
  }, [filter]);

  /* // 判断more按钮是否展示
  useEffect(() => {
    if (loading) return;
    handleResize();
  }, [loading]);

  // 添加resize监听，判断more按钮的显示
  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); */

  return (
    <>
      <div
        className="dbg-studio-overall-projects-development-key-metrics"
        // title="Key Metrics"
        // 这个时间产品说可以写死，取当年
        // operation={`Date: ${/* data?.date */(new Date())?.getFullYear() || '-'}`}
      >
        <div className="dbg-studio-overall-title">
          Key Metrics
          <DataTime style={{ marginLeft: 6 }} dateType="Month" date={dataTime} />
        </div>
        <div className="dbg-studio-overall-projects-development-key-metrics-card">
          <CommonSourceCard
            isLoading={loading}
            isNoData={!devProjectCount?.total}
            icon={<img src={gameIcon} alt="" />}
            title="Total Project counts: In-Development"
            value={getValue(devProjectCount?.total)}
            isPercentage={false}
            slot={
              <ul className="dbg-studio-overall-projects-development-key-metrics-card-category font14">
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Amplifier:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.amplifier)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Astra:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.astra)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Fuel:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.fuel)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Nexus:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.nexus)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Saturn:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.saturn)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Solar:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.solar)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-development-key-metrics-card-category-item">
                  <label>Others:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(devProjectCount?.others)}
                  />
                </li>
              </ul>
            }
          />
          <CommonSourceCard
            isLoading={loading}
            isNoData={!yearProjectCount?.total}
            icon={<img src={gameIcon} alt="" />}
            title="Total counts of launches next 12 months"
            value={getValue(yearProjectCount?.total)}
            isPercentage={false}
            slot={
              // <div className="dbg-studio-overall-projects-development-key-metrics-card-projects-container font14">
              //   <div className="dbg-studio-overall-projects-development-key-metrics-card-projects-box">
              //     {Array.isArray(yearProjectCount?.list) &&
              //       yearProjectCount?.list?.map((t) => {
              //         return (
              //           <ProjectItem
              //             key={t?.id}
              //             src={t?.cover}
              //             title={t?.name || '-'}
              //             platformTranformSolt
              //             solt={
              //               <span
              //                 style={{
              //                   color: '#888',
              //                   display: 'block',
              //                   width: '100%',
              //                 }}
              //               >
              //                 {getValidDate(t?.launch_time, 'YYYY-MM-DD')}
              //               </span>
              //             }
              //             data={t}
              //             toDetails={toDetails}
              //           />
              //         );
              //       })}
              //     {/* More按钮 */}
              //     {
              //       /* Array.isArray(yearProjectCount?.list) && (yearProjectCount?.list as [])?.length > 3 */ visibleMore && (
              //         <div className="dbg-studio-overall-projects-development-key-metrics-card-projects-btn-box">
              //           <span className="dbg-studio-overall-projects-development-key-metrics-card-projects-btn-shade"></span>
              //           <button
              //             className="dbg-studio-overall-projects-development-key-metrics-card-projects-btn"
              //             onClick={() => {
              //               setVisible(true);
              //             }}
              //           >
              //             <span>More</span>
              //             <Iconfont
              //               className="dbg-studio-overall-projects-development-key-metrics-card-projects-btn-arrow"
              //               type="title-arrow"
              //             />
              //           </button>
              //         </div>
              //       )
              //     }
              //   </div>
              // </div>
              <LogoList
                title="Total counts of launches next 12 months"
                logos={yearProjectCount?.list || []}
                defaultLogo={defaultGameIcon}
                getBubbleMsg={(msg: any) => {
                  const dateConfirm = msg?.dateConfirm || '';
                  const date = msg?.date || '';

                  return (
                    <div className="dbg-studio-overall-logo-bubble">
                      <div>{msg?.name || '-'}</div>
                      <div className="dbg-studio-overall-logo-bubble-time">
                        {formatMilestoneDateByStatus(date, dateConfirm) || '-'}
                      </div>
                    </div>
                  );
                }}
                dateFormatter={(data) => {
                  // @ts-ignore
                  const { date, dateConfirm } = data || {};
                  return formatMilestoneDateByStatus(date, dateConfirm);
                }}
                toDetails={toDetails}
                isModalShowItemDate
              />
            }
          />
        </div>
        {/* <div className="dbg-studio-overall-projects-development-key-metrics-chart-cards">
          {chartOpt?.map((t) => {
            return (
              <ChartCard
                key={t?.title}
                title={t?.title}
                data={t?.data}
                loading={loading}
              />
            );
          })}
        </div> */}
      </div>
      {/* More弹窗 */}
      {/* <GeneralModal
        className="dbg-studio-overall-projects-development-key-metrics-card-projects-modal globalpedia-custom-scrollbar"
        visible={visible}
        title="Total counts of launches next 12 months"
        isFont14
        isFooter={false}
        // modalSize="xl"
        content={
          <div className="dbg-studio-overall-projects-development-key-metrics-card-projects-modal-body">
            {Array.isArray(yearProjectCount?.list) &&
              yearProjectCount?.list?.map((t) => {
                return (
                  <ProjectItem
                    key={t?.id}
                    src={t?.cover}
                    title={t?.name || '-'}
                    platformTranformSolt
                    solt={
                      <span
                        style={{
                          color: '#888',
                          display: 'block',
                          width: '100%',
                        }}
                      >
                        {getValidDate(t?.launch_time, 'YYYY-MM-DD')}
                      </span>
                    }
                    data={t}
                    toDetails={toDetails}
                  />
                );
              })}
          </div>
        }
        onClose={() => {
          setVisible(false);
        }}
      /> */}
    </>
  );
}

KeyMetrics.defaultProps = DEFAULT_PROPS;

export default memo(KeyMetrics);
